import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dom-search"
export default class extends Controller {
  static targets = [
    "searchable",
    "scope",
    "input"
  ]

  inputTargetConnected(input) {
    if (input.value) this.search({ target: input })
  }

  search(event) {
    this.query = event.target.value.toLowerCase()
    this.refresh()
  }

  // Re-applies the last query, for content that changed after it was typed.
  refresh() {
    const query = this.query || ""

    this.searchableTargets.filter((element) => !this.hasScopeTarget || this.scopeTarget.contains(element)).forEach((element) => {
      const text = element.dataset.searchValue.toLowerCase()
      const match = text.includes(query)

      if (!match) {
        element.classList.add("hidden")
      } else {
        element.classList.remove("hidden")
      }
    })
  }

  clear() {
    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.focus()
  }
}
